import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import Storefront from "@/pages/Storefront";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import OrdersAdmin from "@/pages/admin/OrdersAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import ReviewsAdmin from "@/pages/admin/ReviewsAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import PaymentsAdmin from "@/pages/admin/PaymentsAdmin";
import ReportsAdmin from "@/pages/admin/ReportsAdmin";
import CategoriesAdmin from "@/pages/admin/CategoriesAdmin";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Storefront />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/products" replace />} />
              <Route path="products" element={<ProductsAdmin />} />
              <Route path="orders" element={<OrdersAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
              <Route path="reviews" element={<ReviewsAdmin />} />
              <Route path="gallery" element={<GalleryAdmin />} />
              <Route path="payments" element={<PaymentsAdmin />} />
              <Route path="reports" element={<ReportsAdmin />} />
              <Route path="categories" element={<CategoriesAdmin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
